import { JobBoard, JobSourcing } from '../models/job-sourcing';
import {
  JobSourcingActions,
  JobSourcingActionTypes,
} from '../actions/job-sourcing.actions';
import { FinnAdvertisement } from '../../lib/classes/finn/finnAdvertisement';

export interface State {
  selectedJobSourcing: JobSourcing;
  selectedEquestDraft: any;
  selectedFinnForm: FinnAdvertisement;
  error: any;
  isUpdating: boolean;
  isUpdateSuccess: boolean;
  selectedBoardsToCheckout: JobBoard[];
  isFinnUpdated: boolean;
  isEquestUpdated: boolean;
}

export const initialState: State = {
  selectedJobSourcing: null,
  selectedEquestDraft: null,
  selectedFinnForm: null,
  error: null,
  isUpdating: false,
  selectedBoardsToCheckout: [],
  isEquestUpdated: false,
  isFinnUpdated: false,
  isUpdateSuccess: false,
};

export function reducer(
  state = initialState,
  action: JobSourcingActions
): State {
  switch (action.type) {
    case JobSourcingActionTypes.LoadJobSourcingSuccess:
      return {
        ...state,
        selectedJobSourcing: action.payload.jobSourcing,
        selectedBoardsToCheckout: action.payload.jobSourcing.job_boards.filter(
          board =>
            board.job_board_specification.product.amount > 0 &&
            board.enabled &&
            board.order_line_id == null
        ),
      };

    case JobSourcingActionTypes.LoadJobSourcing:
      return { ...state, selectedJobSourcing: null };

    case JobSourcingActionTypes.PurchaseJobSourcingBoardSuccess:
      return {
        ...state,
        selectedJobSourcing: action.payload.jobSourcing,
        selectedBoardsToCheckout: action.payload.jobSourcing.job_boards.filter(
          board =>
            board.job_board_specification.product.amount > 0 &&
            board.enabled &&
            board.order_line_id == null
        ),
      };

    case JobSourcingActionTypes.PostFinnBoardSuccess:
      return {
        ...state,
        selectedJobSourcing: action.payload.jobSourcing,
      };
    case JobSourcingActionTypes.SelectFinnBoardSuccess:
      return {
        ...state,
        selectedFinnForm: action.payload.finnAdvertisement,
      };
    case JobSourcingActionTypes.PostEquestBoardSuccess:
      return {
        ...state,
        selectedEquestDraft: action.payload.equestDraft,
      };

    case JobSourcingActionTypes.UpdateJobSourcing:
      return {
        ...state,
        isUpdating: true,
        isUpdateSuccess: null,
      };

    case JobSourcingActionTypes.UpdateJobSourcingSuccess:
      return {
        ...state,
        selectedJobSourcing: action.payload.jobSourcing,
        isUpdating: false,
        isUpdateSuccess: action.payload.isUpdateSuccess,
        selectedBoardsToCheckout: action.payload.jobSourcing.job_boards.filter(
          board =>
            board.job_board_specification.product.amount > 0 &&
            board.enabled &&
            board.order_line_id == null
        ),
      };

    case JobSourcingActionTypes.CleanState:
      return initialState;

    default:
      return state;
  }
}

export const getSelectedJobSourcing = (state: State) =>
  state.selectedJobSourcing;
export const getSelectedEquestDraft = (state: State) =>
  state.selectedEquestDraft;
export const getSelectedFinnForm = (state: State) => state.selectedFinnForm;
export const getSelectedBoardsToCheckout = (state: State) =>
  state.selectedBoardsToCheckout;
